import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
    width: 'auto',
    padding: '0 10px',
  },
  mark: {
    height: 18,
    width: 18,
    borderRadius: '50%',
  },
  label: {
    position: 'absolute',
    top: 30,
    whiteSpace: 'nowrap',
    fontSize: 14,
    [theme.breakpoints.down(480)]: {
      fontSize: 10,
    },
  },
  selectedLabel: {
    color: theme.palette.primary.main,
    fontWeight: 'bold',
  },
  trackContainer: {
    display: 'flex',
    width: '100%',
  },
  track: {
    height: 10,
    width: '100%',
    borderRadius: '4px',
    alignSelf: 'center',
    backgroundColor: theme.palette.primary.main,
  },
  thumb: {
    height: 30,
    width: 30,
    borderRadius: '50%',
    backgroundColor: '#FFF',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    boxShadow: '0px 2px 6px #AAA',
    outline: 'none',
    [theme.breakpoints.down(480)]: {
      height: 26,
      width: 26 },
  },
  thumbInner: {
    borderRadius: '50%',
    height: 18,
    width: 18,
    [theme.breakpoints.down(480)]: {
      height: 15,
      width: 15 },
  },
  output: {
    marginTop: '30px',
  },
}));

export default useStyles;
